import { Component, EventEmitter, Input, Output } from '@angular/core';
import { EnumComposerMenu } from '../../enums/composer-menu.enum';

@Component({
  selector: 'sgt-composer-menu',
  templateUrl: './composer-menu.component.html',
  styleUrls: ['./composer-menu.component.scss']
})
export class ComposerMenuComponent {
  @Input() canAttach = false;
  @Input() canUseActions = false;
  @Input() hasConversationFiles = false;
  @Input() blockedReason = '';

  @Output() deviceRequested = new EventEmitter<void>();
  @Output() conversationRequested = new EventEmitter<void>();
  @Output() actionsRequested = new EventEmitter<void>();
  @Output() opened = new EventEmitter<void>();
  @Output() closed = new EventEmitter<void>();

  view: EnumComposerMenu | null = null;

  get isRoot(): boolean {
    return this.view === EnumComposerMenu.ROOT;
  }

  get isAttach(): boolean {
    return this.view === EnumComposerMenu.ANEXAR;
  }

  get isOpen(): boolean {
    return this.view !== null;
  }

  toggle(): void {
    if (this.isOpen) {
      this.close();
      return;
    }
    this.view = EnumComposerMenu.ROOT;
    this.opened.emit();
  }

  openAttach(): void {
    this.view = EnumComposerMenu.ANEXAR;
  }

  openActions(): void {
    this.view = EnumComposerMenu.ACOES;
    this.actionsRequested.emit();
  }

  backToRoot(): void {
    this.view = EnumComposerMenu.ROOT;
  }

  close(): void {
    this.view = null;
    this.closed.emit();
  }

  onPickFromDevice(): void {
    this.close();
    this.deviceRequested.emit();
  }

  onPickFromConversation(): void {
    this.close();
    this.conversationRequested.emit();
  }
}
